import { Carousel } from '@mantine/carousel';
import { Grid, rem } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import ProductDetailsCard from './ProductDetailsCard';

const CarouselCard = (props) => {
  const products = props?.hits;
  const metrics = props?.metrics;

  const chunkedProducts = products?.reduce((acc, product, index) => {
    if (index % 4 === 0) {
      acc.push([]);
    }
    acc[acc.length - 1].push(product);
    return acc;
  }, []);

  // Don't show carousel controls if there's only one page
  const hasMultiplePages = chunkedProducts?.length > 1;

  return (
    <Carousel
      withIndicators={false}
      withControls={hasMultiplePages}
      loop={hasMultiplePages}
      slideSize="100%"
      slideGap={0}
      align="start"
      nextControlIcon={<IconChevronRight style={{ width: rem(24), height: rem(24) }} />}
      previousControlIcon={<IconChevronLeft style={{ width: rem(24), height: rem(24) }} />}
      styles={{
        root: {
          position: 'relative',
        },
        control: {
          backgroundColor: 'var(--mantine-color-gray-0)',
          border: '1px solid var(--mantine-color-gray-3)',
          boxShadow: 'var(--mantine-shadow-sm)',
          width: rem(36),
          height: rem(36),
          opacity: 1,
          '&[data-inactive]': {
            opacity: 0,
            cursor: 'default',
          },
        },
        controls: {
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          left: 0,
          right: 0,
          padding: '0 4px',
        },
      }}
    >
      {chunkedProducts?.map((chunk, index) => (
        <Carousel.Slide key={index}>
          <Grid px="xl">
            {chunk.map((product, innerIndex) => (
              <ProductDetailsCard key={innerIndex} hit={product} metrics={metrics} />
            ))}
          </Grid>
        </Carousel.Slide>
      ))}
    </Carousel>
  );
};

export default CarouselCard;
